



import {Component, Vue} from 'vue-property-decorator'
import SummaryInfo from '@/components/summary/SummaryInfo.vue'

@Component({
  components: {
    SummaryInfo,
  },
})
export default class Summary extends Vue {}
